import React from 'react';
import Avatar from 'react-avatar';
import { CurrentUserProps } from '../../../shared/prop-types/ChatProps';

const UserCard = (props) => {
  const { currentUser } = props;

  return (
    <div className="chat__user-card">
      {currentUser.chatUserId ? (
        <>
          <Avatar
            size="50"
            round="25px"
            src={currentUser.profilePhoto}
            name={currentUser.name}
          />
          <p className="user-name">{currentUser.name}</p>
        </>
      ) : null}
    </div>
  );
};

UserCard.propTypes = {
  currentUser: CurrentUserProps.isRequired,
};

export default UserCard;
